// @flow
import React, { type Node } from 'react';
import Flex from '@waglabs/flex';
import Text from '@waglabs/text';
import { Link } from 'gatsby';

type Props = {
  to: string,
  children: Node,
  textProps?: any,
};

/**
 * An anchor <a> tag that looks like a button. This is so that visually we
 * display a button to the user, but also so that search engines (for SEO purposes)
 * can crawl through the link specified to gatsby's <Link> component. This will allow for
 * the given page to be listed in search engine results.
 */
export const GatsbyLink = ({
  to,
  children,
  textProps,
  ...others
}: Props) => (
  <Link
    to={to}
  >
    <Flex
      alignItems="center"
      justifyContent="center"
      bg="champagne"
      border={0}
      borderRadius={3}
      height={50}
      hover
      {...others}
    >
      <Text
        hover
        m={0}
        px={3}
        fontSize={[3, 4, 5]}
        {...textProps}
      >
        {children}
      </Text>
    </Flex>
  </Link>
);

GatsbyLink.defaultProps = {
  textProps: {
    color: 'brown4',
  },
};
